import React from "react";

/**
 * Theme-aware switch. Off state uses a bordered track + solid text-colored
 * thumb so it stays visible on both light and dark theme backgrounds.
 */
const Toggle = ({ checked, disabled, onChange, label, className = "" }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={onChange}
    className={`relative h-5 w-9 shrink-0 rounded-full border-2 transition ${
      checked
        ? "border-theme-primary bg-theme-primary"
        : "border-theme-shadow bg-theme-secondary"
    } ${
      disabled
        ? "cursor-not-allowed opacity-45"
        : "cursor-pointer hover:opacity-90"
    } ${className}`}
  >
    <span
      className={`absolute top-px left-px h-3.5 w-3.5 rounded-full shadow-sm transition-transform ${
        checked
          ? "translate-x-4 bg-theme-main"
          : "translate-x-0 bg-theme-text"
      }`}
    />
  </button>
);

export default Toggle;
